import styled from 'styled-components';

export default styled.div`
  display: flex;
  align-items: center;
  justify-self: flex-start;
  margin-right: ${p => p.theme.spacing.small};
  margin-left: 0;
`;
